import { NavLink } from "react-router-dom";
import { FolderLock, Gauge, LayoutGrid, Search } from "lucide-react";

const ITEMS = [
  { to: "/dashboard", label: "Home", es: "Inicio", icon: LayoutGrid, end: true, id: "home" },
  { to: "/dashboard/grants", label: "Grants", es: "Subvenciones", icon: Search, id: "grants" },
  { to: "/dashboard/funding", label: "Funding", es: "Financiamiento", icon: Gauge, id: "funding" },
  { to: "/dashboard/documents", label: "Documents", es: "Documentos", icon: FolderLock, id: "documents" },
];

export function BottomBar({ lang }) {
  return (
    <nav className="lg:hidden fixed bottom-0 inset-x-0 z-40 bg-white/95 backdrop-blur border-t border-slate-200 grid grid-cols-4" style={{ paddingBottom: "env(safe-area-inset-bottom)" }} data-testid="bottom-bar">
      {ITEMS.map((n) => (
        <NavLink key={n.to} to={n.to} end={n.end} data-testid={`bottom-nav-${n.id}`}
          className={({ isActive }) => `flex flex-col items-center justify-center gap-0.5 h-16 text-[11px] font-medium transition-colors ${isActive ? "text-emerald-700" : "text-slate-500 hover:text-slate-900"}`}>
          <n.icon className="h-5 w-5" />
          <span className="truncate max-w-full px-1">{lang === "es" ? n.es : n.label}</span>
        </NavLink>
      ))}
    </nav>
  );
}
